import { queryStatementHasError } from "pages/DevelopWorkspace/contexts/DocumentsContext/helpers/getQueryStatementState";
import { WorkspaceDocument } from "pages/DevelopWorkspace/workspace.types";

const documentHasErrors = (document: WorkspaceDocument) => {
  const execution = document.execution;

  if (!execution) {
    return false;
  }

  const queryStatements = execution.queryStatements;

  if (!queryStatements || queryStatements.length === 0) {
    return false;
  }

  return queryStatements.some(queryStatementHasError);
};

export { documentHasErrors };
